import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { NavMarker } from 'react-rhumb';
import { TOOLBAR_HEIGHT } from '../../../constants/Dimensions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmptyStateThread = ({
  variant
}) => {
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "inbox-thread-loaded",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(View, {
      blockSize: `${TOOLBAR_HEIGHT}px`,
      backgroundColor: "fill-surface-default",
      borderBlockEndColor: "border-core-subtle",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100"
    }), /*#__PURE__*/_jsx(NavMarker, {
      name: "CHAT_FEED_ZERO_STATE_SUCCESS"
    }), /*#__PURE__*/_jsxs(Flex, {
      marginBlockStart: "1500",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Illustration, {
          name: variant === 'no-unread-thread' ? 'all-conversations-complete' : 'conversations-inbox',
          width: "200px"
        })
      }), /*#__PURE__*/_jsx(Box, {
        marginBlockStart: "600",
        children: /*#__PURE__*/_jsx(H2, {
          color: "icon-core-subtle",
          children: variant === 'no-unread-thread' ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.zero-state.noConversations.title"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.zero-state.noFocusedThread"
          })
        })
      }), variant === 'no-unread-thread' && /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Text, {
          color: "icon-core-subtle",
          typography: "body-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.zero-state.noConversations.body"
          })
        })
      })]
    })]
  });
};
EmptyStateThread.displayName = 'EmptyStateThread';
export default EmptyStateThread;